module.exports = __webpack_public_path__ + "roguelock.jpg?52fec944277d5e752a1aeb76759e43a7";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/roguelock.jpg
// module id = 714
// module chunks = 0